"use client";

import React, { useEffect, useMemo, useRef } from "react";
import "./AboutProjectSection.css";

export default function AboutProjectSection({
  projectDetail,
  dispatch,
  setInquiryPopup,
  setInquiryPopupObj,
  isMobilescreen,
}) {
  const sectionRef = useRef(null);

  const plainText = useMemo(() => {
    if (!projectDetail?.big_text_pain) return "";

    const tempDiv = document.createElement("div");

    tempDiv.innerHTML = projectDetail.big_text_pain;

    return tempDiv.textContent?.replace(/\s+/g, " ")?.trim();
  }, [projectDetail]);

  useEffect(() => {
    const section = sectionRef.current;

    if (!section) return;

    const spans = section.querySelectorAll(".reveal-word");

    const onScroll = () => {
      const rect = section.getBoundingClientRect();

      const start = window.innerHeight;
      const end = window.innerHeight * 0.25; // 60vh

      const progress = Math.max(
        0,
        Math.min(1, (start - rect.top) / (start - end)),
      );

      spans.forEach((span, index) => {
        const wordStart = index / spans.length;
        const wordEnd = (index + 1) / spans.length;

        let opacity = (progress - wordStart) / (wordEnd - wordStart);

        opacity = Math.max(0.18, Math.min(1, opacity));

        span.style.opacity = opacity;
      });
    };

    window.addEventListener("scroll", onScroll);

    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!projectDetail?.big_text_pain) return null;

  return (
    <section className="about-project-section section-padding">
      <div className="mini-container">
        <div className="about-project-wrapper inner-flex">
          <div className="about-project-small-title section-paragraph">
            <p className="white-color">About {projectDetail.project_title}</p>
          </div>

          <h2 ref={sectionRef} className="scroll-reveal-text">
            {plainText.split(" ").map((word, index) => (
              <span key={`${word}-${index}`} className="reveal-word">
                {word}{" "}
              </span>
            ))}
          </h2>

          <div className="downloadDataFlex">
            <button
              className={`reecosys-template-button button-style-white-filled ${
                isMobilescreen ? "w100" : ""
              }`}
              onClick={() => {
                dispatch(setInquiryPopupObj(projectDetail));

                dispatch(setInquiryPopup(true));
              }}
            >
              <span className="material-symbols-outlined">chat</span>

              <p>Inquire Now</p>
            </button>

            {projectDetail.document_other_data
              ?.filter((item) => item.type === "Brochure")
              ?.map((item, index) => (
                <button
                  key={index}
                  className={`reecosys-template-button button-style-white ${
                    isMobilescreen ? "w100" : ""
                  }`}
                  onClick={() => {
                    dispatch(setInquiryPopupObj(projectDetail));

                    dispatch(setInquiryPopup(true));
                  }}
                >
                  <span className="material-symbols-outlined">download</span>

                  <p>Download {item.type}</p>
                </button>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
